(() => {
  const ready = fn => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, {once:true}) : fn();
  ready(() => {
    if (!document.querySelector('.bat-header')) return;

    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (standalone) document.documentElement.classList.add('bat-standalone');

    const $ = (s,p=document) => p.querySelector(s);
    const $$ = (s,p=document) => [...p.querySelectorAll(s)];
    const main = document.getElementById('MainContent');
    const FAVORITES_KEY = 'bat_favorites_v1';
    const RECENT_KEY = 'bat_recent_search';
    const TRIPS_KEY = 'bat_trips_v1';
    const HBX_API_BASE = $('[data-bat-hbx-search]')?.dataset.apiBase || 'https://bookatrip-hbx.floot.app';
    const safeParse = (v,fallback) => { try { return JSON.parse(v) ?? fallback } catch { return fallback } };
    const esc = v => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

    const getFavorites = () => safeParse(localStorage.getItem(FAVORITES_KEY), []);
    const setFavorites = list => localStorage.setItem(FAVORITES_KEY, JSON.stringify(list.slice(0,60)));
    const favoriteKey = data => [data.name,data.meta].filter(Boolean).join('|').toLowerCase();

    // Mobile app home dashboard
    if (main && !$('.bat-app-home', main)) {
      const dash = document.createElement('section');
      dash.className = 'bat-app-home';
      dash.innerHTML =
        '<div class="bat-app-home-top">' +
          '<div><span>BOOKATRIP APP</span><h2>Where do you want to go?</h2></div>' +
          '<button class="bat-app-home-install" type="button">Install app</button>' +
        '</div>' +
        '<div class="bat-app-quick-grid">' +
          '<button type="button" data-bat-quick="hotels"><b>⌂</b><strong>Hotels</strong><small>Search stays & rooms</small></button>' +
          '<button type="button" data-bat-quick="flights"><b>✈</b><strong>Flights</strong><small>Compare flights</small></button>' +
          '<button type="button" data-bat-quick="deals"><b>✦</b><strong>Deals</strong><small>Weekend escapes</small></button>' +
          '<button type="button" data-bat-quick="packages"><b>＋</b><strong>Packages</strong><small>Plan more in one place</small></button>' +
        '</div>' +
        '<div class="bat-app-recent" data-bat-app-recent></div>';
      const hero = $('.bat-hero', main);
      if (hero) main.insertBefore(dash, hero); else main.prepend(dash);
    }

    // Full app screens
    let screen = $('.bat-app-screen');
    if (!screen) {
      screen = document.createElement('section');
      screen.className = 'bat-app-screen';
      screen.hidden = true;
      screen.innerHTML =
        '<div class="bat-app-screen-head"><button type="button" class="bat-app-back" aria-label="Back">‹</button><div><small>BookATrip</small><h2 data-bat-screen-title></h2></div></div>' +
        '<div class="bat-app-screen-body" data-bat-screen-body></div>';
      document.body.appendChild(screen);
    }
    const screenTitle = $('[data-bat-screen-title]', screen);
    const screenBody = $('[data-bat-screen-body]', screen);
    const closeScreen = () => { screen.hidden = true; document.body.classList.remove('bat-app-screen-open'); };
    $('.bat-app-back', screen)?.addEventListener('click', closeScreen);

    const renderRecent = () => {
      const host = $('[data-bat-app-recent]');
      if (!host) return;
      const recent = safeParse(localStorage.getItem(RECENT_KEY), null);
      if (!recent?.destination) {
        host.innerHTML = '<div class="bat-app-section-title"><strong>Recent search</strong></div><div class="bat-app-empty-mini">Your latest hotel search will appear here.</div>';
        return;
      }
      host.innerHTML =
        '<div class="bat-app-section-title"><strong>Recent search</strong><button type="button" data-bat-clear-recent>Clear</button></div>' +
        '<button type="button" class="bat-app-recent-card" data-bat-repeat-search>' +
          '<span class="bat-app-recent-icon">⌕</span><span><strong>'+esc(recent.destination)+'</strong><small>'+esc([recent.checkIn,recent.checkOut,recent.adults ? recent.adults+' guest'+(String(recent.adults)==='1'?'':'s') : ''].filter(Boolean).join(' · '))+'</small></span><b>›</b>' +
        '</button>';
      $('[data-bat-clear-recent]',host)?.addEventListener('click',()=>{localStorage.removeItem(RECENT_KEY);renderRecent()});
      $('[data-bat-repeat-search]',host)?.addEventListener('click',()=>repeatRecentSearch(recent));
    };

    const repeatRecentSearch = recent => {
      closeScreen();
      const form = $('[data-bat-hbx-form]');
      if (!form) return;
      const destination = $('[data-bat-hbx-destination]', form);
      const destinationCode = $('[data-bat-hbx-destination-code]', form);
      const checkIn = $('[data-bat-hbx-checkin]', form);
      const checkOut = $('[data-bat-hbx-checkout]', form);
      const adults = $('[data-bat-hbx-adults]', form);
      if (destination) destination.value = recent.destination || '';
      if (destinationCode && recent.destinationCode) destinationCode.value = recent.destinationCode;
      if (checkIn && recent.checkIn) checkIn.value = recent.checkIn;
      if (checkOut && recent.checkOut) checkOut.value = recent.checkOut;
      if (adults && recent.adults) adults.value = recent.adults;
      document.getElementById('hotels')?.scrollIntoView({behavior:'smooth',block:'start'});
      setTimeout(()=>form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true})),350);
    };

    const hotelDataFromCard = card => {
      const name = card.dataset.hotelName || $('h3',card)?.textContent?.trim() || 'Hotel';
      const meta = $('.bat-hbx-meta',card)?.textContent?.trim() || '';
      const price = $('.bat-hbx-price strong',card)?.textContent?.trim() || '';
      const img = $('.bat-hbx-gallery img',card)?.currentSrc || $('.bat-hbx-gallery img',card)?.src || '';
      return {name,meta,price,img,key:favoriteKey({name,meta}),savedAt:Date.now()};
    };

    const updateFavoriteButton = (btn,key) => {
      const saved = getFavorites().some(x=>x.key===key);
      btn.setAttribute('aria-pressed', saved ? 'true':'false');
      btn.textContent = saved ? '♥' : '♡';
      btn.title = saved ? 'Remove from favorites' : 'Save to favorites';
    };

    const decorateHotelCards = () => {
      $$('.bat-hbx-card').forEach(card => {
        if (card.dataset.batFavoriteReady === '1') return;
        card.dataset.batFavoriteReady = '1';
        const data = hotelDataFromCard(card);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bat-app-favorite-button';
        btn.setAttribute('aria-label','Save hotel to favorites');
        updateFavoriteButton(btn,data.key);
        btn.addEventListener('click',e=>{
          e.preventDefault();e.stopPropagation();
          let list=getFavorites();
          const exists=list.some(x=>x.key===data.key);
          list=exists?list.filter(x=>x.key!==data.key):[data,...list.filter(x=>x.key!==data.key)];
          setFavorites(list);
          updateFavoriteButton(btn,data.key);
        });
        card.appendChild(btn);
      });
    };

    const renderFavorites = () => {
      screenTitle.textContent = 'Favorites';
      const list = getFavorites();
      if (!list.length) {
        screenBody.innerHTML =
          '<div class="bat-app-empty-state"><span>♡</span><h3>No favorites yet</h3><p>Tap the heart on any hotel and it will be saved here on this device.</p><button type="button" data-bat-go-hotels>Find hotels</button></div>';
      } else {
        screenBody.innerHTML =
          '<div class="bat-app-favorite-list">'+list.map(item =>
            '<article class="bat-app-favorite-card">'+
              (item.img?'<img src="'+esc(item.img)+'" alt="">':'<div class="bat-app-favorite-placeholder">⌂</div>')+
              '<div class="bat-app-favorite-copy"><strong>'+esc(item.name)+'</strong><small>'+esc(item.meta)+'</small>'+(item.price?'<b>'+esc(item.price)+'</b>':'')+'</div>'+
              '<button type="button" class="bat-app-remove-favorite" data-key="'+esc(item.key)+'" aria-label="Remove favorite">♥</button>'+
            '</article>'
          ).join('')+'</div>';
      }
      $$('[data-bat-go-hotels]',screenBody).forEach(b=>b.addEventListener('click',()=>goHotels()));
      $$('.bat-app-remove-favorite',screenBody).forEach(b=>b.addEventListener('click',()=>{
        setFavorites(getFavorites().filter(x=>x.key!==b.dataset.key));
        renderFavorites();
        decorateHotelCards();
        $$('.bat-app-favorite-button').forEach(btn=>{
          const card=btn.closest('.bat-hbx-card');if(card){const d=hotelDataFromCard(card);updateFavoriteButton(btn,d.key)}
        });
      }));
    };

    const renderTrips = () => {
      screenTitle.textContent = 'My Trips';
      const trips = safeParse(localStorage.getItem(TRIPS_KEY), []);
      if (!trips.length) {
        screenBody.innerHTML =
          '<div class="bat-app-trip-status"><span>HBX TEST</span><strong>Booking setup in progress</strong><p>Your confirmed trips will appear here once HBX Production is activated and a booking is completed.</p></div>' +
          '<div class="bat-app-empty-state"><span>▣</span><h3>No trips yet</h3><p>Search hotels and choose a room. We are keeping real booking confirmation disabled until production access is approved.</p><button type="button" data-bat-go-hotels>Search hotels</button></div>';
      } else {
        screenBody.innerHTML =
          '<div class="bat-app-trip-status"><span>HBX TEST</span><strong>Pending selections</strong><p>These are saved on this device only. They are not confirmed bookings until HBX Production is activated.</p></div>' +
          '<div class="bat-app-trip-list">'+trips.map(t=>
            '<article class="bat-app-trip-card">'+
              (t.imageUrl?'<img src="'+esc(t.imageUrl)+'" alt="">':'')+
              '<div><strong>'+esc(t.hotel||'Trip')+'</strong><small>'+esc(t.room||'')+'</small><small>'+esc([t.checkIn,t.checkOut].filter(Boolean).join(' → '))+'</small>'+
              (t.price?'<b>'+esc((t.currency||'')+' '+t.price)+'</b>':'')+'</div>'+
              '<span>'+esc(t.status||'Pending')+'</span>'+
              (t.reference?'<div class="bat-app-trip-actions"><button type="button" data-bat-voucher="'+esc(t.reference)+'">Voucher</button><button type="button" data-bat-cancel-quote="'+esc(t.reference)+'">Cancellation quote</button></div>':'')+
            '</article>'
          ).join('')+'</div>';
      }
      $('[data-bat-go-hotels]',screenBody).forEach(b=>b.addEventListener('click',()=>goHotels()));
      $('[data-bat-voucher]',screenBody).forEach(b=>b.addEventListener('click',async()=>{
        b.disabled=true;const old=b.textContent;b.textContent='Loading…';
        try{
          const res=await fetch(HBX_API_BASE+'/_api/hbx/voucher?reference='+encodeURIComponent(b.dataset.batVoucher),{headers:{Accept:'application/json'}});
          const data=await res.json();
          if(!res.ok||!data?.ok)throw new Error(data?.message||data?.error||'Voucher unavailable.');
          const v=data.voucher||{};
          alert('Booking '+(v.reference||'')+'\n'+(v.hotel?.name||'Hotel')+'\n'+(v.hotel?.checkIn||'')+' → '+(v.hotel?.checkOut||''));
        }catch(err){alert(err?.message||'Voucher unavailable.')}finally{b.disabled=false;b.textContent=old}
      }));
      $('[data-bat-cancel-quote]',screenBody).forEach(b=>b.addEventListener('click',async()=>{
        b.disabled=true;const old=b.textContent;b.textContent='Checking…';
        try{
          const res=await fetch(HBX_API_BASE+'/_api/hbx/cancel',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({reference:b.dataset.batCancelQuote,mode:'SIMULATION'})});
          const data=await res.json();
          if(!res.ok||!data?.ok)throw new Error(data?.message||data?.error||'Cancellation quote unavailable.');
          alert('HBX cancellation simulation completed. No cancellation was made.');
        }catch(err){alert(err?.message||'Cancellation quote unavailable.')}finally{b.disabled=false;b.textContent=old}
      }));
    };

    const openScreen = name => {
      if (name==='favorites') renderFavorites();
      if (name==='trips') renderTrips();
      screen.hidden=false;
      document.body.classList.add('bat-app-screen-open');
      screen.scrollTop=0;
    };

    const goHotels = () => {
      closeScreen();
      document.getElementById('hotels')?.scrollIntoView({behavior:'smooth',block:'start'});
    };
    const goAnchor = id => {
      closeScreen();
      document.getElementById(id)?.scrollIntoView({behavior:'smooth',block:'start'});
    };

    // Bottom app navigation
    const oldNav = $('.bat-app-bottom-nav');
    if (oldNav) oldNav.remove();
    const nav = document.createElement('nav');
    nav.className = 'bat-app-bottom-nav';
    nav.setAttribute('aria-label','BookATrip app navigation');
    nav.innerHTML =
      '<button type="button" data-bat-tab="home"><span>⌂</span>Home</button>' +
      '<button type="button" data-bat-tab="hotels"><span>⌕</span>Hotels</button>' +
      '<button type="button" data-bat-tab="favorites"><span>♡</span>Favorites</button>' +
      '<button type="button" data-bat-tab="trips"><span>▣</span>My Trips</button>';
    document.body.appendChild(nav);
    $$('[data-bat-tab]',nav).forEach(btn=>btn.addEventListener('click',()=>{
      const tab=btn.dataset.batTab;
      if(tab==='home'){closeScreen();window.scrollTo({top:0,behavior:'smooth'})}
      if(tab==='hotels')goHotels();
      if(tab==='favorites')openScreen('favorites');
      if(tab==='trips')openScreen('trips');
    }));

    // Install prompt
    let deferredPrompt = null;
    const isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);
    const dismissedAt = Number(localStorage.getItem('bat_app_install_dismissed') || 0);
    const recentlyDismissed = dismissedAt && (Date.now() - dismissedAt) < 7*24*60*60*1000;
    let install = $('.bat-app-install');
    if (install) install.remove();
    install = document.createElement('aside');
    install.className='bat-app-install';
    install.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0766/0830/7414/files/bookatrip-app-icon-192.png?v=1790920720" alt="">' +
      '<div class="bat-app-install-copy"><strong>Install BookATrip</strong><small>'+(isiOS?'Tap Share, then Add to Home Screen.':'Add BookATrip to your home screen.')+'</small></div>'+
      '<button class="bat-app-install-action" type="button">'+(isiOS?'How':'Install')+'</button>'+
      '<button class="bat-app-install-close" type="button" aria-label="Close">×</button>';
    document.body.appendChild(install);
    const showInstall=()=>{if(!standalone&&isMobile&&!recentlyDismissed)install.dataset.visible='true'};
    window.addEventListener('beforeinstallprompt',e=>{e.preventDefault();deferredPrompt=e;showInstall()});
    if(isiOS)setTimeout(showInstall,1400);
    $('.bat-app-install-close',install)?.addEventListener('click',()=>{install.dataset.visible='false';localStorage.setItem('bat_app_install_dismissed',String(Date.now()))});
    $('.bat-app-install-action',install)?.addEventListener('click',async()=>{
      if(deferredPrompt){deferredPrompt.prompt();try{await deferredPrompt.userChoice}catch{} deferredPrompt=null;install.dataset.visible='false';return}
      if(isiOS)$('.bat-app-install-copy small',install).textContent='In Safari: tap Share, then choose “Add to Home Screen”.';
    });
    $('.bat-app-home-install')?.addEventListener('click',()=>{install.dataset.visible='true'});

    // Quick actions
    $$('[data-bat-quick]').forEach(btn=>btn.addEventListener('click',()=>{
      const q=btn.dataset.batQuick;
      if(q==='hotels')goHotels();
      if(q==='flights')goAnchor('flights');
      if(q==='deals')goAnchor('weekend-deals');
      if(q==='packages')goAnchor('packages');
    }));

    // Save recent searches, including destination code.
    const form = $('[data-bat-hbx-form]');
    if (form) {
      form.addEventListener('submit',()=>{
        const destination=$('[data-bat-hbx-destination]',form)?.value||'';
        const destinationCode=$('[data-bat-hbx-destination-code]',form)?.value||'';
        const checkIn=$('[data-bat-hbx-checkin]',form)?.value||'';
        const checkOut=$('[data-bat-hbx-checkout]',form)?.value||'';
        const adults=$('[data-bat-hbx-adults]',form)?.value||'';
        if(destination)localStorage.setItem(RECENT_KEY,JSON.stringify({destination,destinationCode,checkIn,checkOut,adults,at:Date.now()}));
        renderRecent();
      });
    }

    const resultHost = $('[data-bat-hbx-results]') || main;
    if (resultHost) {
      const observer = new MutationObserver(()=>decorateHotelCards());
      observer.observe(resultHost,{childList:true,subtree:true});
    }

    // HBX CheckRate progress / failure feedback.
    let checkRateOverlay=null;
    const ensureCheckRateOverlay=()=>{
      if(checkRateOverlay)return checkRateOverlay;
      checkRateOverlay=document.createElement('div');
      checkRateOverlay.className='bat-checkrate-overlay';
      checkRateOverlay.hidden=true;
      checkRateOverlay.innerHTML='<div class="bat-checkrate-card"><div class="bat-checkrate-spinner"></div><strong data-bat-checkrate-title>Checking room…</strong><small data-bat-checkrate-copy>Reconfirming availability, final price and cancellation terms with HBX.</small></div>';
      document.body.appendChild(checkRateOverlay);
      return checkRateOverlay;
    };
    const showCheckRateOverlay=(title,copy)=>{
      const o=ensureCheckRateOverlay();
      $('[data-bat-checkrate-title]',o).textContent=title||'Checking room…';
      $('[data-bat-checkrate-copy]',o).textContent=copy||'Reconfirming availability, final price and cancellation terms with HBX.';
      o.hidden=false;
    };
    const hideCheckRateOverlay=()=>{if(checkRateOverlay)checkRateOverlay.hidden=true};
    const showCheckRateError=message=>{
      const o=ensureCheckRateOverlay();
      const card=$('.bat-checkrate-card',o);
      card.innerHTML='<div class="bat-checkrate-error-icon">!</div><strong>Room could not be reconfirmed</strong><small>'+esc(message||'Please choose another rate and try again.')+'</small><button type="button" data-bat-checkrate-close>Close</button>';
      o.hidden=false;
      $('[data-bat-checkrate-close]',o)?.addEventListener('click',()=>{o.hidden=true;checkRateOverlay=null;o.remove()},{once:true});
    };
    document.addEventListener('bat:checkrate-start',e=>{
      showCheckRateOverlay('Checking '+(e.detail?.roomName||'room')+'…','Reconfirming availability, latest price and cancellation terms with HBX.');
    });
    document.addEventListener('bat:checkrate-failed',e=>{
      showCheckRateError(e.detail?.message||'HBX CheckRate failed.');
    });

    // Room selection -> guest details -> review booking flow.
    let bookingSheet = $('.bat-booking-sheet');
    let selectedBooking = null;

    const formatPolicy = (selection) => {
      const policies = Array.isArray(selection?.cancellationPolicies) ? selection.cancellationPolicies : [];
      if (String(selection?.rateClass||'').toUpperCase()==='NRF') {
        return '<strong>Non-refundable</strong><small>This HBX rate is marked non-refundable.</small>';
      }
      if (!policies.length) {
        return '<strong>'+esc(selection?.cancellationLabel||'Flexible / standard')+'</strong><small>Final cancellation terms will be confirmed before a production booking is submitted.</small>';
      }
      return policies.slice(0,3).map(p=>{
        const when=p.from?('From '+esc(p.from)):'Cancellation policy';
        const amount=p.amount?(' · '+esc(selection.currency||'')+' '+esc(p.amount)):'';
        return '<div><strong>'+when+amount+'</strong></div>';
      }).join('');
    };

    const upsertPendingTrip = selection => {
      if (!selection?.rateKey) return;
      let trips = safeParse(localStorage.getItem(TRIPS_KEY), []);
      const id = 'pending:'+selection.rateKey;
      const trip = {
        id,
        status:'Pending production',
        hotel:selection.hotelName,
        hotelCode:selection.hotelCode,
        room:selection.roomName,
        roomCode:selection.roomCode,
        board:selection.boardName,
        price:selection.price,
        currency:selection.currency,
        checkIn:selection.checkIn,
        checkOut:selection.checkOut,
        adults:selection.adults,
        children:selection.children,
        imageUrl:selection.imageUrl||'',
        savedAt:Date.now()
      };
      trips=[trip,...trips.filter(t=>t.id!==id)].slice(0,20);
      localStorage.setItem(TRIPS_KEY,JSON.stringify(trips));
    };

    const ensureBookingSheet = () => {
      if (bookingSheet) return bookingSheet;
      bookingSheet = document.createElement('section');
      bookingSheet.className='bat-booking-sheet';
      bookingSheet.hidden=true;
      bookingSheet.innerHTML =
        '<div class="bat-booking-sheet-card">' +
          '<div class="bat-booking-sheet-head"><div><small>BOOKATRIP · HOTEL BOOKING</small><h2>Guest details</h2></div><button type="button" class="bat-booking-close" aria-label="Close">×</button></div>' +
          '<div class="bat-booking-sheet-body" data-bat-booking-body></div>' +
        '</div>';
      document.body.appendChild(bookingSheet);
      $('.bat-booking-close',bookingSheet)?.addEventListener('click',()=>closeBooking());
      bookingSheet.addEventListener('click',e=>{if(e.target===bookingSheet)closeBooking()});
      return bookingSheet;
    };

    const closeBooking = () => {
      if (!bookingSheet) return;
      bookingSheet.hidden=true;
      document.body.classList.remove('bat-booking-open');
    };

    const bookingBody = () => $('[data-bat-booking-body]',ensureBookingSheet());

    const renderGuestStep = () => {
      const b=bookingBody();
      const s=selectedBooking||{};
      b.innerHTML =
        '<div class="bat-booking-verified"><span>✓ HBX CheckRate verified</span><small>Availability, price and cancellation terms were reconfirmed before checkout.</small></div>' +
        '<div class="bat-booking-selection">' +
          (s.imageUrl?'<img src="'+esc(s.imageUrl)+'" alt="">':'') +
          '<div><strong>'+esc(s.hotelName||'Hotel')+'</strong><span>'+esc(s.roomName||'Room')+'</span><small>'+esc([s.checkIn,s.checkOut].filter(Boolean).join(' → '))+'</small></div>' +
          '<b>'+esc((s.currency||'')+' '+(s.price||''))+'</b>' +
        '</div>' +
        '<form class="bat-booking-guest-form" data-bat-guest-form>' +
          '<div class="bat-booking-grid">' +
            '<label><span>First name</span><input name="firstName" autocomplete="given-name" required></label>' +
            '<label><span>Last name</span><input name="lastName" autocomplete="family-name" required></label>' +
            '<label class="bat-booking-wide"><span>Email</span><input name="email" type="email" autocomplete="email" required></label>' +
            '<label class="bat-booking-wide"><span>Phone</span><input name="phone" type="tel" autocomplete="tel" required></label>' +
          '</div>' +
          '<div class="bat-booking-policy"><span>Cancellation</span>'+formatPolicy(s)+'</div>' +
          '<button type="submit" class="bat-booking-primary">Continue to review</button>' +
          '<p class="bat-booking-test-note">No real reservation or payment is submitted at this stage.</p>' +
        '</form>';
      const form=$('[data-bat-guest-form]',b);
      form?.addEventListener('submit',e=>{
        e.preventDefault();
        if(!form.reportValidity())return;
        const fd=new FormData(form);
        selectedBooking={...selectedBooking,guest:{
          firstName:String(fd.get('firstName')||'').trim(),
          lastName:String(fd.get('lastName')||'').trim(),
          email:String(fd.get('email')||'').trim(),
          phone:String(fd.get('phone')||'').trim()
        }};
        renderReviewStep();
      });
    };

    const renderReviewStep = () => {
      const b=bookingBody();
      const s=selectedBooking||{}, g=s.guest||{};
      $('.bat-booking-sheet-head h2',bookingSheet).textContent='Review booking';
      b.innerHTML =
        '<div class="bat-booking-verified"><span>✓ HBX CheckRate verified</span><small>Final rate checked before booking review.</small></div>' +
        '<div class="bat-booking-review-card">' +
          (s.imageUrl?'<img class="bat-booking-review-image" src="'+esc(s.imageUrl)+'" alt="">':'') +
          '<h3>'+esc(s.hotelName||'Hotel')+'</h3>' +
          '<p>'+esc(s.roomName||'Room')+'</p>' +
          '<div class="bat-booking-review-row"><span>Dates</span><strong>'+esc([s.checkIn,s.checkOut].filter(Boolean).join(' → '))+'</strong></div>' +
          '<div class="bat-booking-review-row"><span>Guests</span><strong>'+esc((s.adults||'1')+' adult'+(String(s.adults)==='1'?'':'s')+(Number(s.children)?' · '+s.children+' child'+(Number(s.children)===1?'':'ren'):'') )+'</strong></div>' +
          '<div class="bat-booking-review-row"><span>Board</span><strong>'+esc(s.boardName||'Room rate')+'</strong></div>' +
          '<div class="bat-booking-review-row"><span>Guest</span><strong>'+esc([g.firstName,g.lastName].filter(Boolean).join(' '))+'</strong></div>' +
          '<div class="bat-booking-review-row"><span>Email</span><strong>'+esc(g.email||'')+'</strong></div>' +
          '<div class="bat-booking-policy"><span>Cancellation</span>'+formatPolicy(s)+'</div>' +
          '<div class="bat-booking-total"><span>Total / HBX rate</span><strong>'+esc((s.currency||'')+' '+(s.price||''))+'</strong></div>' +
        '</div>' +
        '<button type="button" class="bat-booking-primary bat-booking-locked" disabled>Confirm booking — available after HBX Production</button>' +
        '<button type="button" class="bat-booking-secondary" data-bat-edit-guest>Edit guest details</button>' +
        '<button type="button" class="bat-booking-secondary" data-bat-open-trips>View pending trip</button>' +
        '<p class="bat-booking-test-note">The room is saved in My Trips as pending. No booking has been sent to HBX and no payment has been charged.</p>';
      $('[data-bat-edit-guest]',b)?.addEventListener('click',()=>{
        $('.bat-booking-sheet-head h2',bookingSheet).textContent='Guest details';
        renderGuestStep();
      });
      $('[data-bat-open-trips]',b)?.addEventListener('click',()=>{
        closeBooking();
        openScreen('trips');
      });
    };

    document.addEventListener('bat:room-selected',e=>{
      hideCheckRateOverlay();
      const s=e.detail||{};
      if(!s.rateKey)return;
      selectedBooking=s;
      upsertPendingTrip(s);
      const sheet=ensureBookingSheet();
      $('.bat-booking-sheet-head h2',sheet).textContent='Guest details';
      renderGuestStep();
      sheet.hidden=false;
      document.body.classList.add('bat-booking-open');
    });


    renderRecent();
    decorateHotelCards();
  });
})();